import {Attribute} from '../../../components/ObjectAttribute';
import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';

const searchUomsRequest: RequestExample = {
    title: {
        verb: 'GET',
        endpointUrl: '/api/uoms',
    },
    curl:
        `curl --location \\
--request GET '<YOUR SERVER>/api/uoms' \\
--header 'Content-Type: application/json' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};
const searchUomsResponse: Json = {
    title: 'RESPONSE',
    json: {
        "totalCount": 1,
        "totalPages": 1,
        "pageNumber": 1,
        "pageSize": 100,
        "results": [
            {
                "id": 1,
                "name": "Each",
                "abbreviation": "ea",
                "description": "A single item.",
                "type": "Count",
                "active": true
            }
        ]
    },
};

const searchUomsQueryParameters: Attribute[] = [
    {
        name: 'pageNumber',
        type: 'integer',
        optional: true,
        description: 'The current page of the results.'
    },
    {
        name: 'pageSize',
        type: 'integer',
        optional: true,
        description: 'The number of returned results per page. (Default 100)'
    },
    {
        name: 'name',
        type: 'string',
        optional: true,
        description: 'The UOM name.',
    },
    {
        name: 'abbreviation',
        type: 'string',
        optional: true,
        description: 'The UOM abbreviation.',
    },
    {
        name: 'description',
        type: 'string',
        optional: true,
        description: 'The UOM description.',
    },
    {
        name: 'type',
        type: 'string: \'Area\' | \'Count\' | \'Length\' | \'Time\' | \'Volume\' | \'Weight\'',
        optional: true,
        description: 'The basic type of the UOM.',
    },
    {
        name: 'active',
        type: 'boolean',
        optional: true,
        description: 'The active status of the UOM.',
    },
];

const searchUomsAttributes: Attribute[] = [];

const data: RequestDefinitionData = {
    id: 'search-uom',
    title: 'Search for units of measure',
    description: 'Searches for units of measure.',
    endpoint: {
        verb: 'GET',
        path: '/uoms',
        tooltip: 'Search for UOMs',
    },
    attributes: searchUomsAttributes,
    requestObject: searchUomsRequest,
    responseObject: searchUomsResponse,
    queryParameters: searchUomsQueryParameters,
}

export default data;
